import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row } from 'react-flexbox-grid';

const HistoryEntryColumns = ({ children }) => (
  <Grid fluid>
    <Row>{children}</Row>
  </Grid>
);

HistoryEntryColumns.propTypes = {
  children: PropTypes.node,
};

export default HistoryEntryColumns;
